"use strict";

$(document).ready(function () {
    if ($('.select2').length > 0) {
        $('.select2').select2({
            theme: 'bootstrap'
        });
    }
});

/* Legacy */
(function () {
    let generalModal = $('#generalModal');
    let errorModal = $('#errorModal');

    $('input,textarea').attr('autocomplete', 'off');
    $('[data-toggle="tooltip"]').tooltip();

    $('a[href="#"]').click(function (e) {
        e.preventDefault();
    });

    let dateOptions = {
        locale: {
            format: 'DD.MM.YYYY',
            customRangeLabel: "Manual choice",
            firstDay: 1,
            cancelLabel: "Cancel",
            applyLabel: "Apply"
        },
        ranges: {
            "Today": [moment(), moment()],
            "Yesterday": [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            "Last week": [moment().subtract(1, 'week').startOf('isoWeek'), moment().subtract(1, 'week').endOf('isoWeek')],
            "Last month": [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            "Last year": [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
        },
        alwaysShowCalendars: true,
        showCustomRangeLabel: true,
        showISOWeekNumbers: true
    };

    let exportsScripts = (function () {
        let panel = $('.exports');
        if (!panel.length) {
            return;
        }
        panel.find('input[name="dates"]').daterangepicker(dateOptions);
    })();

    let dashboardScripts = (function () {
        let panel = $('.dashboard');
        if (!panel.length) {
            return;
        }
        panel.find('input[name="dates"]').daterangepicker(dateOptions);
    })();


    $('.datepicker').daterangepicker({
        autoClose: true,
        singleDatePicker: true,
        showDropdowns: true,
        minDate: '01.01.2006',
        locale: {
            format: 'DD.MM.YYYY',
            firstDay: 1,
            cancelLabel: "Cancel",
            applyLabel: "Apply"
        },
        showISOWeekNumbers: true
    });


    let contractArchiveScripts = (function () {
        let panel = $('.contract-archive');
        if (!panel.length) {
            return;
        }

        panel.find('input[name="dates"]').daterangepicker(dateOptions);
    })();

    let paymentPaidLoanScripts = (function () {
        let panel = $('.payment-paid-loan');
        if (!panel.length) {
            return;
        }

        let resultContainer = panel.find('.result-container');

        resultContainer.on('click', '#preparePay', function () {
            let payLoanModal = panel.find('#payLoanModal');
            payLoanModal.modal('show');
        });

        resultContainer.on('change', '#paidLoanModal input[type="checkbox"]', function () {
            let $this = $(this);
            let button = panel.find('#finishPayLoan');
            if ($this.is(':checked')) {
                button.prop('disabled', false);
            } else {
                button.prop('disabled', true);
            }
        });

        resultContainer.on('click', '#payLoan', function () {
            ajaxPrepare();
            let $this = $(this);
            let postData = getFormData(resultContainer.find('#payLoanForm'));
            setButtonLoading($this);

            $.ajax({
                type: 'POST',
                url: '/rest/payment/payLoan',
                data: postData,
                dataType: 'json',
                success: function (response) {
                    let payLoanModal = panel.find('#payLoanModal');
                    payLoanModal.modal('hide');
                    removeButtonLoading($this);

                    if (response.status) {
                        let paidLoanModal = panel.find('#paidLoanModal');
                        paidLoanModal.find('a[href="#"]').attr('href', response.data.link);
                        paidLoanModal.on('hide.bs.modal', function (e) {
                            window.location.reload();
                        });
                        paidLoanModal.modal('show');
                    } else {
                        let error = '';
                        if (response.data.errors) {
                            let errors = response.data.errors;
                            error = errors[Object.keys(errors)[0]];
                        }
                        showErrorModule(error);
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown);
                removeButtonLoading($this);
            });
        });

        panel.find('.search-form').submit(function (e) {
            e.preventDefault();
            ajaxPrepare();
            let $this = $(this);
            let postData = getFormData($this.closest('form'));
            let button = $this.find('input[type="submit"]');

            setButtonLoading(button);
            resultContainer.html('');

            $.ajax({
                type: 'GET',
                url: '/rest/payment/searchPaidLoanUser',
                data: postData,
                dataType: 'json',
                success: function (response) {
                    removeButtonLoading(button);
                    if (response.status) {
                        clearErrors(panel);
                        resultContainer.html(response.data.html);
                    } else {
                        if (response.data.errors) {
                            setErrors(panel, response.data.errors);
                        } else {
                            clearErrors(panel);
                            resultContainer.html('<p class="p-error">' + panel.data('error-msg') + '</p>');
                        }
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown, reloadDocument());
                removeButtonLoading(button);
            });
        });
    })();

    let paymentInstallmentScripts = (function () {
        let panel = $('.payment-installment');
        if (!panel.length) {
            return;
        }

        let resultContainer = panel.find('.result-container');

        resultContainer.on('keyup', 'input[name="amount"]', function () {
            ajaxPrepare();
            let $this = $(this);
            let table = $this.closest('table')
            let postData = getFormData($this.closest('.pay-installment-form'));
            postData.type = 'normal';
            taxCalculation(postData, table)
        });

        resultContainer.on('keyup', 'input[name="total"]', function () {
            let $this = $(this);
            let table = $this.closest('table')
            let postData = getFormData($this.closest('.pay-installment-form'));
            postData.type = 'reverse';
            taxCalculation(postData, table);
        });

        let request = null;

        function taxCalculation(data, table) {
            if (request) {
                request.abort();
                request = null;
            }
            ajaxPrepare();
            request = $.ajax({
                type: 'POST',
                url: '/rest/payment/installmentTaxCalculation',
                data: data,
                dataType: 'json',
                success: function (response) {
                    if (response.status) {
                        if (data.type == 'normal') {
                            table.find('input[name="total"]').val(response.data.total);
                        } else {
                            table.find('input[name="amount"]').val(response.data.amount);
                        }
                        table.find('.tax').text(response.data.tax);
                    }
                }
            });
        }

        resultContainer.on('click', '.prepare-installment', function () {
            ajaxPrepare();
            let postData = getFormData($(this).closest('.pay-installment-form'));
            let amount = postData.amount.trim();
            if (amount == '' || amount <= 0) {
                return;
            }

            $.ajax({
                type: 'POST',
                url: '/rest/payment/prepareInstallment',
                data: postData,
                dataType: 'json',
                success: function (response) {
                    if (response.status) {
                        let payInstallmentModal = panel.find('#payInstallmentModal');
                        payInstallmentModal.find('.label-amount').text(response.data.amount);
                        payInstallmentModal.find('.label-tax').text(response.data.tax);
                        payInstallmentModal.find('.label-total').text(response.data.total);
                        payInstallmentModal.find('#payInstallment').attr('contract-id', response.data.contract_id);
                        payInstallmentModal.modal('show');
                    } else {
                        let error = '';
                        if (response.data.errors) {
                            let errors = response.data.errors;
                            error = errors[Object.keys(errors)[0]];
                        }
                        showErrorModule(error);
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown);
            });
        });

        resultContainer.on('click', '#payInstallment', function () {
            ajaxPrepare();
            let $this = $(this);
            let contractId = $this.attr('contract-id');
            let postData = getFormData(panel.find('.row-item[id="' + contractId + '"]').find('.pay-installment-form'));
            setButtonLoading($this);

            $.ajax({
                type: 'POST',
                url: '/rest/payment/payInstallment',
                data: postData,
                dataType: 'json',
                success: function (response) {
                    let payInstallmentModal = panel.find('#payInstallmentModal');
                    payInstallmentModal.modal('hide');
                    removeButtonLoading($this);

                    if (response.status) {
                        let paidInstallmentModal = panel.find('#paidInstallmentModal');
                        paidInstallmentModal.find('a[href="#"]').attr('href', response.data.link);

                        let link = panel.find('.row-item[id="' + contractId + '"]').find('.prepare-installment');
                        $('<i class="icon-success-save"></i>').insertAfter(link);
                        link.remove();

                        paidInstallmentModal.modal('show');
                    } else {
                        let error = '';
                        if (response.data.errors) {
                            let errors = response.data.errors;
                            error = errors[Object.keys(errors)[0]];
                        }
                        showErrorModule(error);
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                let payInstallmentModal = panel.find('#payInstallmentModal');
                payInstallmentModal.modal('hide');
                showErrorModule(errorThrown);
                removeButtonLoading($this);
            });
        });

        panel.find('.search-form').submit(function (e) {
            e.preventDefault();
            ajaxPrepare();
            let $this = $(this);
            let postData = getFormData($this.closest('form'));
            let button = $this.find('input[type="submit"]');

            setButtonLoading(button);
            resultContainer.html('');

            $.ajax({
                type: 'GET',
                url: '/rest/payment/searchInstallmentUser',
                data: postData,
                dataType: 'json',
                success: function (response) {
                    removeButtonLoading(button);
                    if (response.status) {
                        clearErrors(panel);
                        resultContainer.html(response.data.html);
                    } else {
                        if (response.data.errors) {
                            setErrors(panel, response.data.errors);
                        } else {
                            clearErrors(panel);
                            resultContainer.html('<p class="p-error">' + panel.data('error-msg') + '</p>');
                        }
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown, reloadDocument());
                removeButtonLoading(button);
            });
        });
    })();

    let reloadDocument = function () {
        return document.location.reload();
    };

    let operatorsScripts = (function () {
        let panel = $('.operators-container');
        if (!panel.length) {
            return;
        }

        let addButton = panel.find('.insertOperator');
        let operatorInsertForm = panel.find('.operators-container-insert');

        addButton.click(function (e) {
            e.preventDefault();
            let $this = $(this);
            $this.closest('.insert-btn-container').hide();
            let form = $this.closest('.department-row').find('.operators-container-insert');
            form.slideDown();
        });

        operatorInsertForm.find('input[type="reset"]').click(function () {
            let $this = $(this);
            let form = $this.closest('.department-row').find('.operators-container-insert');

            form.hide();
            $this.closest('.department-row').find('.insert-btn-container').show();
        });

        let operatorInnactiveForm = panel.find('.operators-container-inactive');
        operatorInnactiveForm.find('.toggle-btn').click(function (e) {
            e.preventDefault();
            let table = $(this).closest('.operators-container-inactive').find('.toggle-container');
            table.slideToggle();
        });

        panel.on('click', '.btn-deactivate', function (e) {
            e.preventDefault();
            ajaxPrepare();
            let tr = $(this).closest('tr');
            let container = tr.closest('.department-row');
            let userId = tr.data('id');

            $.ajax({
                type: 'POST',
                url: '/rest/operator/deactivate',
                data: {
                    user_id: userId
                },
                dataType: 'json',
                success: function (response) {
                    if (response.status) {
                        insertRowInactive(container, response.data);
                        tr.remove();
                        checkEmptyMessage();
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown);
            });
        });

        panel.on('click', '.btn-activate', function (e) {
            e.preventDefault();
            ajaxPrepare();
            let tr = $(this).closest('tr');
            let container = tr.closest('.department-row');
            let userId = tr.data('id');

            $.ajax({
                type: 'POST',
                url: '/rest/operator/activate',
                data: {
                    user_id: userId
                },
                dataType: 'json',
                success: function (response) {
                    if (response.status) {
                        insertRow(container, response.data);
                        tr.remove();
                        checkEmptyMessage();
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown);
            });
        });

        panel.on('click', '.btn-department-deactivate', function (e) {
            e.preventDefault();
            ajaxPrepare();
            let container = $(this).closest('.department-row');
            let departmentId = container.data('department-id');

            $.ajax({
                type: 'POST',
                url: '/rest/operator/department/deactivate',
                data: {
                    department_id: departmentId
                },
                dataType: 'json',
                success: function (response) {
                    if (response.status) {
                        container.addClass('disabled');
                        container.find('.btn-department-deactivate').hide();
                        container.find('.btn-department-activate').show();
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown);
            });
        });

        panel.on('click', '.btn-department-activate', function (e) {
            e.preventDefault();
            ajaxPrepare();
            let container = $(this).closest('.department-row');
            let departmentId = container.data('department-id');

            $.ajax({
                type: 'POST',
                url: '/rest/operator/department/activate',
                data: {
                    department_id: departmentId
                },
                dataType: 'json',
                success: function (response) {
                    if (response.status) {
                        container.removeClass('disabled');
                        container.find('.btn-department-activate').hide();
                        container.find('.btn-department-deactivate').show();
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown);
            });
        });

        panel.find('.table-active-users').on('change', '.rule-change-selector', function (e) {
            e.preventDefault();
            ajaxPrepare();
            let $this = $(this);
            let tr = $(this).closest('tr');
            let userId = tr.data('id');

            $.ajax({
                type: 'POST',
                url: '/rest/operator/changeRole',
                data: {
                    user_id: userId,
                    role: $this.val()
                },
                dataType: 'json',
                success: function (response) {
                    if (response.status) {
                        $this.addClass('saved');
                        setTimeout(function () {
                            $this.removeClass('saved');
                        }, 3000);
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown);
            });
        });

        panel.find('.table-active-users').on('input', '.change-password-field input', function () {
            ajaxPrepare();
            let $this = $(this);
            let saveButton = $this.closest('.change-password-field').find('.save-btn');
            let value = $this.val();

            if (value.length > 3) {
                saveButton.removeClass('hide').show();
            } else {
                saveButton.addClass('hide').hide();
            }
        });
        panel.find('.table-active-users').on('click', '.change-password-field .save-btn', function (e) {
            e.preventDefault();
            ajaxPrepare();
            let $this = $(this);
            let saveButton = $this.closest('.change-password-field').find('.save-btn');
            let successIcon = $this.closest('.change-password-field').find('.success-icon');
            let tr = $this.closest('tr');
            let userId = tr.data('id');
            let input = tr.find('input[type="password"]');

            $.ajax({
                type: 'POST',
                url: '/rest/operator/changePassword',
                data: {
                    user_id: userId,
                    password: input.val()
                },
                dataType: 'json',
                success: function (response) {
                    if (response.status) {
                        clearErrors(tr);
                        saveButton.hide();

                        successIcon.fadeIn();
                        setTimeout(function () {
                            successIcon.fadeOut();
                        }, 3000);

                        checkEmptyMessage();
                    } else {
                        setErrors(tr, response.data.errors);
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown);
            });
        });


        operatorInsertForm.find('.btn-submit').click(function () {
            ajaxPrepare();
            let postData = getFormData($(this).closest('form'));
            let container = $(this).closest('.department-row');

            $.ajax({
                type: 'POST',
                url: '/rest/operator/create',
                data: postData,
                dataType: 'json',
                success: function (response) {
                    if (response.status) {
                        clearErrors(operatorInsertForm);
                        container.find('.operators-container-insert').hide();
                        container.find('.insert-btn-container').show();
                        operatorInsertForm.find('input[type="text"],input[type="password"]').val('');
                        insertRow(container, response.data);
                        checkEmptyMessage();
                    } else {
                        setErrors(operatorInsertForm, response.data.errors);
                    }
                }
            }).fail(function (xhr, textStatus, errorThrown) {
                showErrorModule(errorThrown);
            });
        });

        function checkEmptyMessage() {
            $.each(panel.find('.empty-message'), function (index, value) {
                let message = $(value)
                if (message.prev('table').find('tbody').find('tr').length) {
                    message.hide();
                } else {
                    message.show();
                }
            });
        }

        function insertRow(container, data) {
            let selectHtml,
                passwordHtml,
                actionsHtml;

            let roles = panel.find('#rolesData').length ? JSON.parse(panel.find('#rolesData').val()) : {};
            selectHtml = '<select class="form-control rule-change-selector" name="rule">';
            $.each(roles, function (index, value) {
                selectHtml += '<option value="' + index + '"';
                if (data.rule == index) {
                    selectHtml += ' selected ';
                }
                selectHtml += '>' + value + '</option>';
            });
            selectHtml += '</select>';

            passwordHtml = '<input type="password" name="password" value="" class="form-control" required/><a href="#" class="save-btn hide"><i class="icon-save"></i></a><span class="success-icon hide"><i class="icon-success-save"></i></span>';
            actionsHtml = '<a href="#" class="btn-deactivate"><i class="fas fa-ban text-danger"></i></ion-icon></a>';

            let html =
                "<tr class='' data-id='" + data.id + "'>" +
                "<td>" + data.name + "</td>" +
                "<td>" + data.email + "</td>" +
                "<td>" + selectHtml + "</td>" +
                "<td><div class='change-password-field'>" + passwordHtml + "</div></td>" +
                "<td>" + actionsHtml + "</td>" +
                "</tr>";

            let tbody = container.find('.table-active-users').find('tbody');
            tbody.append(html);
        }

        function insertRowInactive(container, data) {
            let selectHtml,
                passwordHtml,
                actionsHtml;

            selectHtml = '<input type="text" class="form-control" readonly="readonly" value="' + data.ruleLabel + '">';
            passwordHtml = '<input type="password" name="password" value="********" readonly="readonly" class="form-control" required/>';
            actionsHtml = '<a href="#" class="btn-activate"><i class="icon-enable"></i></a>';

            let html =
                "<tr class='' data-id='" + data.id + "'>" +
                "<td width=\"20%\">" + data.name + "</td>" +
                "<td width=\"30%\">" + data.email + "</td>" +
                "<td width=\"25%\">" + selectHtml + "</td>" +
                "<td width=\"20%\">" + passwordHtml + "</td>" +
                "<td width=\"5%\">" + actionsHtml + "</td>" +
                "</tr>";

            let tbody = container.find('.table-inactive-users').find('tbody');
            tbody.append(html);
        }
    })();

    let departmentsScripts = (function () {
        let panel = $('.departments-container');
        if (!panel.length) {
            return;
        }

        let addButton = panel.find('#insertDepartment');
        let departmentsInsertForm = panel.find('.department-container-insert');
        addButton.click(function (e) {
            e.preventDefault();
            departmentsInsertForm.slideDown();
        });

        departmentsInsertForm.find('input[type="reset"]').click(function () {
            departmentsInsertForm.hide();
        });
    })();

    /*
     * Helpers
     */
    function ajaxPrepare() {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
    }

    function showErrorModule(text, onCloseCallback) {
        if (!text) {
            text = 'Unknown error';
        }
        if (!onCloseCallback) {
            onCloseCallback = function () {
            };
        }

        errorModal.find('.modal-body').find('.error-container').html(text);
        errorModal.modal('show');
        errorModal.on('hide.bs.modal', onCloseCallback);
    }

    function getFormData(form) {
        let unindexedArray = form.serializeArray();
        let indexedArray = {};
        $.map(unindexedArray, function (n, i) {
            indexedArray[n['name']] = n['value'];
        });
        return indexedArray;
    }

    function clearErrors(panel) {
        panel.find('.tmp-error').remove();
    }

    function setErrors(panel, data) {
        $.each(panel.find('.tmp-error'), function (index, value) {
            $(value).removeClass('tmp-error').addClass('tmp-error-old');
        });

        $.each(data, function (index, value) {
            let splitArray = index.split('.')
            let field = panel.find('input[name^="' + splitArray[0] + '"]');

            let errorOld = field.parent().find('.tmp-error-old');
            if (errorOld.length) {
                errorOld.text(value).removeClass('tmp-error-old').addClass('tmp-error');
            } else {
                let errorHtml = '<div class="text-danger tmp-error">' + value + '</div>';
                $(errorHtml).insertAfter(field)
            }
        });

        panel.find('.tmp-error-old').remove();
    }

    function setButtonLoading(button) {
        button.prop('disabled', true);
        button.data('value', button.val());
        button.val('Loading...');
    }

    function removeButtonLoading(button) {
        button.prop('disabled', false);
        button.val(button.data('value'));
    }
})();
